import { FiatCurrency } from '__generated__/globalTypes';

import { useCurrentUserCurrencies } from './useCurrentUserCurrencies';

export const useMangopayCreditCardsEnabled = () => {
  const { fiatCurrency } = useCurrentUserCurrencies();
  return fiatCurrency !== FiatCurrency.USD;
};
